<div class="print row mt-4">
  <div class="printable-table-wrapper">
    <table>
      <ng-content></ng-content>
    </table>
  </div>
</div>
